module.exports = __webpack_public_path__ + "static/img/fnedu.9110d52f.png";